import { useApi } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';
import { Grid, Typography, Tooltip, Button } from '@material-ui/core';
import React, { useCallback } from 'react';

const GithubNotAuthorized = ({
  hostname = "github.com",
  addLoginStatus
}) => {
  const scmAuth = useApi(scmAuthApiRef);
  const signIn = useCallback(async () => {
    const credentials = await scmAuth.getCredentials({
      url: `https://${hostname}/`,
      additionalScope: {
        customScopes: {
          github: ["repo"]
        }
      }
    });
    if (credentials.token) {
      addLoginStatus();
    }
  }, [scmAuth, hostname, addLoginStatus]);
  return /* @__PURE__ */ React.createElement(Grid, { container: true }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 8 }, /* @__PURE__ */ React.createElement(Typography, null, "You are not logged into GitHub. You need to be signed in to see the content of this card.")), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4, container: true, justifyContent: "flex-end" }, /* @__PURE__ */ React.createElement(Tooltip, { placement: "top", arrow: true, title: "Sign in to Github" }, /* @__PURE__ */ React.createElement(Button, { variant: "outlined", color: "primary", onClick: signIn }, "Sign in"))));
};

export { GithubNotAuthorized };
//# sourceMappingURL=GitHubNotAuthorized.esm.js.map
